<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj pole
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.name"
                    class="pt-0"
                    label="Nazwa pola"
                    placeholder=" "
                ></v-text-field>
              <v-select
                  v-model="form.width"
                  :items="widths"
                  label="Szerokość"
              ></v-select>
                <v-select
                    v-model="form.type"
                    @change="fieldTypeChanged(item)"
                    :items="fieldTypes"
                    label="Typ"
                ></v-select>
                <v-text-field
                    v-if="form.type === 'select'"
                    v-model="form.options"
                    class="pt-0"
                    hint="Oddziel opcje przecinkiem np. gotówka,przelew"
                    label="Opcje"
                    placeholder=" "
                ></v-text-field>
                <v-checkbox
                    v-model="form.availableWithTransport"
                    label="Widoczne w ofertach z transportem"
                >Widoczne w ofertach z transportem</v-checkbox>
                <v-checkbox
                    v-model="form.availableWithoutTransport"
                    label="Widoczne w ofertach bez transportu"
                >Widoczne w ofertach bez transportue</v-checkbox>
                <v-checkbox
                  v-model="form.isRequired"
                  label="Jest wymagane"
                  >Jest wymagane</v-checkbox>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'

export default {
  name: 'ModalAddServiceField',
  components: {  },
  props: {
    item: {},
  },
  mixins: [
      transactionTypeMixin,
      transportConditionMixin,
      categoryMixin,
      priceMixin,
      paymentConditionMixin,
      dateMixin,
      validationHelpers
  ],
  created() {
  },
  data: () => ({
    partners: [],
    unit: "",
    dialog: false,
    form: {
      name: '',
      type: '',
      width: 6,
      availableWithTransport: true,
      availableWithoutTransport: true,
      isRequired: '',
      options: '',
    },
    formRules: {
      name: [(value) => value.length === 0 || 'Wpisz nazwę'],
      type: [(value) => value.length === 0 || 'Wybierz typ'],
    },
    valid: false,
    fieldTypes: ['input', 'textarea', 'datetime', 'select', 'file'],
    widths: Array.from({length: 12}, (_, i) => i + 1),
  }),
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const field = {
        name: this.form.name,
        type: this.form.type,
        width: this.form.width,
        options: this.form.options ?? null,
        availableWithTransport: this.form.availableWithTransport ?? true,
        availableWithoutTransport: this.form.availableWithoutTransport ?? true,
        isRequired: this.form.isRequired ?? false,
      }
      api
          .post('/api/service-field/' + this.item, field)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Pole zostało dodane.',
            });
            this.dialog = false;
            this.form.name = '';
            this.form.type = '';
            this.form.width = 6;
            this.form.availableWithTransport = true;
            this.form.availableWithoutTransport = true;
            this.form.isRequired = false;
            this.form.options = '';
            this.$parent.loadFields();
          })
          .catch((error) => {
            console.error('Error when adding a dimension:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
    fieldTypeChanged(field) {
      if (field.type !== 'select') {
        field.options = null;
      }
    },
  },
}
</script>

<style scoped></style>
